import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './ReturnStepType.module.scss';
import withInspector from 'fulogics-ui-web/dist/layout/inspector/hoc/withInspector';

import ReturnStepTypeSchema from './ReturnStepTypeSchema';
import { IdType } from 'fulogics-ui-core/dist/api/models/IdType';
import { enTMSItemType } from 'fulogics-ui-core/dist/api/models/enums/TMSSystem/enTMSItemType';

const ReturnStepType = ({ data, showPayload, onPayloadClick, className }: ReturnStepTypeProps) => {
    const { t } = useTranslation('ReturnStepType');

    const handlePayloadClick = useCallback(() => {
        onPayloadClick && onPayloadClick(data);
    }, [onPayloadClick]);

    return (
        <div className={classNames(styles.container, className)}>
            {data?.type ? <div>{t(`type.${data?.type}`)}</div> : '-'}
            {showPayload && !!data?.payload?.carrierCount && (
                <label className={classNames(styles.payload)} onClick={handlePayloadClick}>
                    {t('carrier', {
                        count: data?.payload?.carrierCount,
                    })}
                </label>
            )}
        </div>
    );
};

export type ReturnStepTypeProps = {
    data?: ReturnStepTypeData;
} & ReturnStepTypeDisplayOptions;

export default withInspector<ReturnStepTypeProps>(ReturnStepType, ReturnStepTypeSchema);

export class ReturnStepTypeDisplayOptions {
    id?: string;
    className?: string;
    showPayload?: boolean;
    //
    onPayloadClick?: (data?: ReturnStepTypeData) => void;
}

export type ReturnStepTypeData = {
    id?: IdType;
    payload?: {
        carrierCount?: number;
    };
    type?: enTMSItemType;
};
export const ReturnStepTypeDataKeys = ['id', 'type', 'payload.carrierCount'];
